/**
 * Shared utilities for managing URL params in report pages
 */

/**
 * Get params string excluding 'tab' parameter
 */
function getParamsWithoutTab(searchParams: URLSearchParams): string {
  const params = new URLSearchParams(searchParams);
  params.delete('tab');
  return params.toString();
}

/**
 * Restore saved params into URLSearchParams
 */
function restoreParamsInto(newParams: URLSearchParams, savedParamsString: string): void {
  const savedParams = new URLSearchParams(savedParamsString);
  savedParams.forEach((value, key) => {
    newParams.append(key, value);
  });
}

/**
 * Update URL params with filters and pagination
 */
function updateUrlParams(
  searchParams: URLSearchParams,
  setSearchParams: (
    nextInit: URLSearchParams | ((prev: URLSearchParams) => URLSearchParams),
    navigateOptions?: { replace?: boolean }
  ) => void,
  filters: { clients: string[]; flags?: string[] },
  pagination?: { page: number; limit: number }
): void {
  const newSearchParams = new URLSearchParams(searchParams);

  // Remove existing filter params
  newSearchParams.delete('clients');
  newSearchParams.delete('flags');
  newSearchParams.delete('page');
  newSearchParams.delete('limit');

  // Add new filter params
  filters.clients.forEach(clientId => {
    newSearchParams.append('clients', clientId);
  });
  if (filters.flags && filters.flags.length > 0) {
    filters.flags.forEach(flag => {
      newSearchParams.append('flags', flag);
    });
  }

  // Add pagination params if provided
  if (pagination) {
    newSearchParams.set('page', pagination.page.toString());
    newSearchParams.set('limit', pagination.limit.toString());
  }

  setSearchParams(newSearchParams, { replace: true });
}

// Namespace export for convenient usage: urlParams.getParamsWithoutTab()
export const urlParams = {
  getParamsWithoutTab,
  restoreParamsInto,
  updateUrlParams,
} as const;

